import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withStyles, Grid } from '@material-ui/core';
import { UserCard, FHEContainerScroll, FHEContainer, FHEContainerForm, FHEItemText, FHEDivider, FHETitle } from 'data/components';
import { Toastr } from 'data/common';
import { SvgSDM17SPG } from 'data/common/iconsvg';

import {
    getSDM17SPGDetails,
    refreshSDM17SPGStatus,
    switchSDM17SPGMaster,
    dissociateSDM17SPGUser,
    dissociateSDM17SPGUserAndSwitchMaster
} from '../../data/SDM17SPG/actions';

class SDM17SPGDetail extends PureComponent {
    static propTypes = {
        getSDM17SPGDetails: PropTypes.func.isRequired,
        dissociateSDM17SPGUser: PropTypes.func.isRequired,
        dissociateSDM17SPGUserAndSwitchMaster: PropTypes.func.isRequired,
        switchSDM17SPGMaster: PropTypes.func.isRequired,
        refreshSDM17SPGStatus: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        SDM17SPG: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            actionDisabled: false
        };
    }

    componentDidMount() {
        this.getSDM17SPGDetails();
    }

    getSDM17SPGDetails = () => {
        const { getSDM17SPGDetails, match } = this.props;

        this.setState({ loading: true, error: null });

        getSDM17SPGDetails(match.params.SDM17SPGId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false
                });
            });
    };

    switchSDM17SPGMaster = (SDM17SPGMac, userId) => {
        const { switchSDM17SPGMaster } = this.props;

        return switchSDM17SPGMaster(SDM17SPGMac, userId)
            .then(data => {
                Toastr.success(Translator.translate('generic.user.actions.switchSuccess'));
                return data;
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.switchError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSDM17SPGUser = (SDM17SPGMac, userId) => {
        const { dissociateSDM17SPGUser } = this.props;

        return dissociateSDM17SPGUser(SDM17SPGMac, userId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSDM17SPGUserAndSwitchMaster = (SDM17SPGMac, userId, masterId) => {
        const { dissociateSDM17SPGUserAndSwitchMaster } = this.props;

        return dissociateSDM17SPGUserAndSwitchMaster(SDM17SPGMac, userId, masterId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    enableActions = () => {
        this.setState({
            actionDisabled: false
        });
    };

    disableActions = () => {
        this.setState({
            actionDisabled: true
        });
    };

    refreshStateSDM17SPG = () => {
        const { refreshSDM17SPGStatus, match } = this.props;

        return refreshSDM17SPGStatus(match.params.SDM17SPGId)
            .then(() => {
                Toastr.success(Translator.translate('general.products.SDM17SPG.table.action.refresh.success'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('general.products.SDM17SPG.table.action.refresh.error')
                );
                throw err;
            });
    };

    renderUserList() {
        const { usersLoading, actionDisabled } = this.state;
        const { SDM17SPG, profile } = this.props;
        const users = [];

        if (!usersLoading && SDM17SPG.has('otherUsers')) {
            SDM17SPG.get('otherUsers').map(user => {
                const isMaster = SDM17SPG.get('userMasterId') === user.get('_id');
                let otherUsers = [];
                if (isMaster) {
                    SDM17SPG.get('otherUsers').map(user => {
                        if (user.get('_id') !== SDM17SPG.get('userMasterId'))
                            otherUsers.push({ id: user.get('_id'), label: `${user.get('firstname')} ${user.get('lastname')}` });
                    });
                }
                users.push(
                    <Grid key={user.get('_id')} container item sm={12} md={6} xl={4}>
                        <UserCard
                            isMaster={isMaster}
                            user={user}
                            profile={profile}
                            product={SDM17SPG}
                            productName="SDM17SPG"
                            environment="myfhe"
                            dissociateUserFunc={this.dissociateSDM17SPGUser}
                            dissociateUserAndSwitchMasterFunc={this.dissociateSDM17SPGUserAndSwitchMaster}
                            switchMasterFunc={this.switchSDM17SPGMaster}
                            actionDisabled={actionDisabled}
                            disableActions={this.disableActions}
                            enableActions={this.enableActions}
                            otherUsers={otherUsers}
                        />
                    </Grid>
                );
            });
            return (
                <Grid container spacing={3}>
                    {users}
                </Grid>
            );
        }
    }
    renderPartDetail = () => {
        const { SDM17SPG, classes } = this.props;
        return (
            <Grid container spacing={3}>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.switchState')}
                        itemContent={SDM17SPG.get('switchState')}
                        classContent={SDM17SPG.get('switchState') === 'ON' ? classes.connectedColor : classes.disconnectedColor}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.defaultSwitchState')}
                        itemContent={SDM17SPG.get('defaultSwitchState')}
                        classContent={SDM17SPG.get('defaultSwitchState') === 'ON' ? classes.connectedColor : classes.disconnectedColor}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.operatingMode')}
                        itemContent={Translator.translate(`general.data.mode.${SDM17SPG.get('mode')}`)}
                    />
                </Grid>
            </Grid>
        );
    };
    renderChildren = () => {
        const { loading } = this.state;
        const { SDM17SPG, classes } = this.props;
        return (
            <Fragment>
                <FHETitle title={SDM17SPG.get('label')} Icon={SvgSDM17SPG} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.macAddress')}
                                    itemContent={
                                        SDM17SPG.get('macAddress')
                                            ? SDM17SPG.get('macAddress')
                                                  .match(/.{1,2}/g)
                                                  .join(':')
                                            : 'N/A'
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.firmwareVersion')}
                                    itemContent={SDM17SPG.get('firmwareVersion')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate('general.products.SDM17SPG.table.action.refresh.tooltip')}
                                    onClick={this.refreshStateSDM17SPG}
                                    itemTitle={Translator.translate('general.table.column.state')}
                                    itemContent={Translator.translate(`general.${SDM17SPG.get('state')}`)}
                                    classContent={SDM17SPG.get('state') === 'disconnected' ? classes.disconnectedColor : classes.connectedColor}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.email')} itemContent={SDM17SPG.get('userEmail')} />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    <FHEDivider title={Translator.translate('general.details')} />

                    <FHEContainerForm loading={loading} onRender={this.renderPartDetail} />
                    <FHEDivider title={Translator.translate('general.Users')} />

                    {this.renderUserList()}
                </FHEContainerScroll>
            </Fragment>
        );
    };

    render() {
        const { loading, error } = this.state;
        const { initialized } = this.props;
        return (
            <FHEContainer
                withBackIcon
                loading={loading && !initialized}
                error={error}
                onClickFunc={this.getSDM17SPGDetails}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const users = state.environments.myfhe.data.Users.get('list');
    let SDM17SPG = state.environments.myfhe.data.SDM17SPG.getIn(['list', props.match.params.SDM17SPGId], new Map());
    if (SDM17SPG.get('usersList')) {
        let otherUsers = [];
        let masterUser = new Map();
        SDM17SPG.get('usersList').forEach(userId => {
            users.find(user => {
                if (userId === user.get('_id')) {
                    if (masterUser.size === 0 && SDM17SPG.get('userMasterId') === user.get('_id')) {
                        masterUser = user;
                        otherUsers.unshift(user);
                    } else {
                        otherUsers.push(user);
                    }
                }
            });
        });
        SDM17SPG = SDM17SPG.setIn(['userEmail'], masterUser.get('email')).setIn(['otherUsers'], otherUsers);
    }
    return {
        profile: state.data.user,
        SDM17SPG,
        initialized: state.environments.myfhe.data.SDM17SPG.get('initialized')
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch =>
            bindActionCreators(
                { getSDM17SPGDetails, refreshSDM17SPGStatus, switchSDM17SPGMaster, dissociateSDM17SPGUser, dissociateSDM17SPGUserAndSwitchMaster },
                dispatch
            )
    )(withStyles(styles, { withTheme: true })(SDM17SPGDetail))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/SDM17SPG/details.js